<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4 ml-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Company
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- Left side: Form fields -->
            <v-col sm="8">
              <v-row>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.name"
                    outlined
                    label="Company Name *"
                    prepend-inner-icon="mdi-buffet"
                    :error-messages="errors.name"
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.email"
                    outlined
                    label="Email *"
                    prepend-inner-icon="mdi-email"
                    :error-messages="errors.email"
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.contact_person"
                    outlined
                    label="Contact Person *"
                    prepend-inner-icon="mdi-card-account-phone"
                    :error-messages="errors.contact_person"
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.phone"
                    outlined
                    label="Phone *"
                    prepend-inner-icon="mdi-phone"
                    :error-messages="errors.phone"
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field
                    v-model="form.address"
                    outlined
                    label="Address *"
                    prepend-inner-icon="mdi-map-marker-multiple"
                    :error-messages="errors.address"
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-switch
                    v-model="form.is_active"
                    inset
                    :label="`Is Active: ${
                      form.is_active.toString() == 'true' ? 'YES' : 'NO'
                    }`"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <!-- Right side: Logo -->
            <v-col sm="4">
              <v-card outlined class="pa-4 text-center">
                <div class="text-subtitle-2 mb-3">Company Logo</div>

                <!-- Current logo display -->
                <div v-if="currentLogoUrl && !logoPreview" class="mb-3">
                  <v-img
                    :src="currentLogoUrl"
                    max-height="150"
                    contain
                    class="mx-auto"
                  ></v-img>
                  <div class="mt-3">
                    <v-btn small color="primary" outlined class="mr-2" @click="viewLogo">
                      <v-icon small left>mdi-eye</v-icon> View
                    </v-btn>
                    <v-btn small color="red" outlined @click="removeLogo">
                      <v-icon small left>mdi-delete</v-icon> Remove
                    </v-btn>
                  </div>
                </div>

                <!-- New logo preview -->
                <div v-else-if="logoPreview" class="mb-3">
                  <v-img
                    :src="logoPreview"
                    max-height="150"
                    contain
                    class="mx-auto"
                  ></v-img>
                  <div class="mt-3">
                    <v-btn small color="red" outlined @click="cancelNewLogo">
                      <v-icon small left>mdi-close</v-icon> Cancel
                    </v-btn>
                  </div>
                </div>

                <!-- No logo placeholder -->
                <div v-else class="mb-3 py-6" style="background: #f5f5f5; border-radius: 8px;">
                  <v-icon size="48" color="grey lighten-1">mdi-image-off</v-icon>
                  <div class="text-caption grey--text mt-2">No logo uploaded</div>
                </div>

                <v-file-input
                  v-model="logoFile"
                  outlined
                  dense
                  label="Upload New Logo"
                  prepend-icon="mdi-camera"
                  accept="image/*"
                  :error-messages="errors.logo"
                  @change="previewLogo"
                  hide-details
                ></v-file-input>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save">
            Update Company
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Logo View Dialog -->
      <v-dialog v-model="logoDialog" max-width="600">
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            <span>Company Logo</span>
            <v-btn icon @click="logoDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center pa-6">
            <v-img
              :src="currentLogoUrl"
              contain
              max-height="400"
              class="mx-auto"
            ></v-img>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "CompanyEditPage",
  data() {
    return {
      form: {
        name: "",
        is_active: true,
        logo_path: "",
      },
      isLoading: false,
      logoFile: null,
      logoPreview: null,
      logoDialog: false,
    };
  },
  computed: {
    currentLogoUrl() {
      if (this.form.logo_path) {
        return this.mediaUrl + this.form.logo_path;
      }
      return null;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    previewLogo() {
      if (this.logoFile) {
        this.logoPreview = URL.createObjectURL(this.logoFile);
      } else {
        this.logoPreview = null;
      }
    },
    viewLogo() {
      this.logoDialog = true;
    },
    removeLogo() {
      this.form.logo_path = "";
      this.logoFile = null;
      this.logoPreview = null;
    },
    cancelNewLogo() {
      this.logoFile = null;
      this.logoPreview = null;
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/companies/${this.$route.params.companyId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;

        // Upload logo if new file selected
        if (this.logoFile) {
          let formData = new FormData();
          formData.append("logo", this.logoFile);
          formData.append("company_id", this.$route.params.companyId);
          let uploadResponse = await axios.post("/upload_company_logo", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (uploadResponse.data.data.logo_path) {
            this.form.logo_path = uploadResponse.data.data.logo_path;
          }
        }

        await axios.patch(
          `/companies/${this.$route.params.companyId}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/companies");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
